import { render, staticRenderFns } from "./Reinsurance.vue?vue&type=template&id=35f5fce7&scoped=true&name=reinsurance&"
import script from "./Reinsurance.vue?vue&type=script&lang=js&"
export * from "./Reinsurance.vue?vue&type=script&lang=js&"
import style0 from "./Reinsurance.vue?vue&type=style&index=0&id=35f5fce7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f5fce7",
  null
  
)

/* custom blocks */
import block0 from "./Reinsurance.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports